<template>
  <div style="width: 100%; height: 100%; position: absolute">
    <iframe :src="book" style="width: 100%; height: 100%"> </iframe>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      book: "",
    };
  },
  async created() {
    await this.loadMediaMagazine();
    this.viewBook();
  },
  methods: {
    viewBook() {
      switch (this.$route.params.id) {
        case "1":
          this.book = this.media[20];
          break;
        case "2":
          this.book = this.media[39];
          break;
        case "3":
          this.book = this.media[50];
          break;
        case "4":
          this.book = this.media[78];
          break;
        case "5":
          this.book = this.media[85];
          break;
        case "6":
          this.book = this.media[126];
          break;
        case "7":
          this.book = this.media[131];
          break;
        case "8":
          this.book = this.media[143];
          break;
        case "9":
          this.book = this.media[145];
          break;
        case "11":
          this.book = this.media[151];
          break;
        case "12":
          this.book = this.media[153];
          break;
        default:
          break;
      }
    },
    ...mapActions("magazine", ["loadMediaMagazine"]),
  },
  computed: {
    ...mapState("magazine", ["media"]),
  },
};
</script>